
/// <summary>
/// Property Contested
/// 0 = Not contested.
/// 1 = Contested by us.
/// 2 = Contested by them.
/// 3 = [Blank].
/// 4 = Unsure.
/// 5 = Prospective (hope to be able to prove).
/// </summary>
export class Contested {
  readonly displayText: string;
  readonly value: number;
  private constructor(displayText:string,value:number) {
    this.displayText = displayText;
    this.value = value;
  }

  public static displayText(key: number): string {
    return Contested.All.find(c => c.value === key).displayText;
  }

  public static readonly NotContested = new Contested('Not Contested.', 0);
  public static readonly ContestedByUs = new Contested('Contested by us', 1);
  public static readonly ContestedByThem = new Contested('Contested by them', 2);
  public static readonly Blank = new Contested('[Blank]', 3);
  public static readonly Unsure = new Contested('Unsure', 4);
  public static readonly Prospective = new Contested('Prospective', 5);
  public static readonly All = [Contested.NotContested, Contested.ContestedByUs, Contested.ContestedByThem, Contested.Blank, Contested.Unsure, Contested.Prospective];
}